export default __webpack_public_path__ + "static/media/wedding2.2c899752.webp";